(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fe-preorder-ui"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__feNativePreorderBound) return;
  window.__feNativePreorderBound = true;

  function parseVariants(form) {
    var node = form.querySelector('[data-fe-variants]');
    if (!node) return [];
    try { return JSON.parse(node.textContent || '[]'); } catch (error) { return []; }
  }

  function selectedVariantId(form) {
    var field = form.querySelector('[name="id"]');
    if (field && field.value && field.value !== 'not-selected') return String(field.value);
    var selection = form.querySelector('[data-variant-selection]');
    if (selection) {
      var value = selection.getAttribute('variant');
      if (value && value !== 'not-selected') return String(value);
    }
    return '';
  }

  function findVariant(variants, id) {
    id = String(id || '');
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === id) return variants[i];
    }
    return null;
  }

  function productScope(form) {
    return form.closest('.product--outer') || form.closest('[data-product-wrapper]') || form.parentElement || document;
  }

  function productMarker(form) {
    return productScope(form).querySelector('[data-fe-preorder-badge][data-fe-preorder-context="product"]');
  }

  function isPreorder(marker, variant) {
    if (!marker) return false;
    if (marker.getAttribute('data-fe-preorder-force') === 'true') return true;
    if (!variant) return false;
    var policy = String(variant.inventory_policy || '').toLowerCase();
    var quantity = Number(variant.inventory_quantity || 0);
    return policy === 'continue' && quantity <= 0;
  }

  function formatDate(raw) {
    if (!raw) return '';
    var date = new Date(raw + 'T12:00:00');
    if (isNaN(date.getTime())) return raw;
    try { return new Intl.DateTimeFormat('it-IT', { day:'numeric', month:'long', year:'numeric' }).format(date); }
    catch (error) { return raw; }
  }

  function preorderCopy(marker) {
    var custom = marker ? String(marker.getAttribute('data-fe-preorder-message') || '').trim() : '';
    var dateRaw = marker ? String(marker.getAttribute('data-fe-preorder-date') || '').trim() : '';
    if (custom) return custom;
    if (dateRaw) return 'Disponibilità prevista: ' + formatDate(dateRaw) + '.';
    return 'Ordinalo ora: verrà spedito non appena il prodotto sarà disponibile.';
  }

  function ensurePanel(form) {
    var panel = form.querySelector('[data-fe-preorder-panel]');
    if (panel) return panel;
    var atc = form.querySelector('.product-form--atc');
    if (!atc || !atc.parentNode) return null;
    panel = document.createElement('div');
    panel.className = 'fe-preorder-panel';
    panel.setAttribute('data-fe-preorder-panel', '');
    panel.hidden = true;
    panel.innerHTML = '<div class="fe-preorder-panel__top"><span class="fe-preorder-panel__pill">PRE-ORDINE</span><span class="fe-preorder-panel__title">Disponibile in pre-ordine</span></div><p class="fe-preorder-panel__text" data-fe-preorder-panel-text></p>';
    atc.parentNode.insertBefore(panel, atc);
    return panel;
  }

  function ensureMediaBadge(form) {
    var gallery = productScope(form).querySelector('.product-gallery');
    if (!gallery) return null;
    var badge = gallery.querySelector('[data-fe-preorder-media-badge]');
    if (badge) return badge;
    badge = document.createElement('span');
    badge.className = 'fe-preorder-media-badge';
    badge.setAttribute('data-fe-preorder-media-badge', '');
    badge.textContent = 'PRE-ORDINE';
    badge.hidden = true;
    gallery.insertBefore(badge, gallery.firstChild);
    return badge;
  }

  function setNormalBadges(form, active) {
    productScope(form).querySelectorAll('.product__badge:not([data-fe-preorder-badge])').forEach(function (badge) {
      if (active) {
        if (!badge.hasAttribute('data-fe-preorder-old-display')) badge.setAttribute('data-fe-preorder-old-display', badge.style.display || '');
        badge.style.display = 'none';
      } else if (badge.hasAttribute('data-fe-preorder-old-display')) {
        badge.style.display = badge.getAttribute('data-fe-preorder-old-display') || '';
        badge.removeAttribute('data-fe-preorder-old-display');
      }
    });
  }

  function syncShippingTab(form, marker, active) {
    var section = form.closest('.shopify-section') || document;
    var tab = section.querySelector('#fe-ship');
    if (!tab) return;
    var note = tab.querySelector('[data-fe-preorder-shipping-note]');
    if (!note) {
      note = document.createElement('p');
      note.className = 'fe-preorder-shipping-note';
      note.setAttribute('data-fe-preorder-shipping-note', '');
      note.hidden = true;
      tab.insertBefore(note, tab.firstChild);
    }
    tab.querySelectorAll('p').forEach(function (paragraph) {
      if (paragraph === note) return;
      var text = (paragraph.textContent || '').toLowerCase();
      var isTiming = text.indexOf('spedizione in italia') !== -1 || text.indexOf('spedizione in europa') !== -1;
      if (!isTiming) return;
      if (active) {
        paragraph.setAttribute('data-fe-preorder-timing-hidden', 'true');
        paragraph.style.display = 'none';
      } else if (paragraph.getAttribute('data-fe-preorder-timing-hidden') === 'true') {
        paragraph.style.display = '';
        paragraph.removeAttribute('data-fe-preorder-timing-hidden');
      }
    });
    if (active) {
      note.textContent = '⏳ Articolo in pre-ordine. ' + preorderCopy(marker);
      note.hidden = false;
    } else note.hidden = true;
  }

  function syncEta(form, marker, variant, active) {
    var block = form.querySelector('[data-fe-ship-eta]');
    if (!block || !variant) return;
    var icon = block.querySelector('.fe-ship-eta__icon');
    var text = block.querySelector('.fe-ship-eta__text');
    if (!text) return;
    if (active) {
      block.style.display = 'flex';
      block.classList.add('fe-ship-eta--preorder');
      block.classList.remove('fe-ship-eta--instock','fe-ship-eta--urgent','fe-ship-eta--oos');
      if (icon) icon.textContent = '⏳';
      text.textContent = 'Pre-ordine · ' + preorderCopy(marker);
      return;
    }
    var policy = String(variant.inventory_policy || '').toLowerCase();
    var quantity = Number(variant.inventory_quantity || 0);
    if (marker && policy === 'continue' && quantity > 0) {
      block.style.display = 'flex';
      block.classList.remove('fe-ship-eta--preorder','fe-ship-eta--urgent','fe-ship-eta--oos');
      block.classList.add('fe-ship-eta--instock');
      if (icon) icon.textContent = '🚚';
      text.textContent = 'Disponibile a magazzino · spedizione standard';
    }
  }

  function syncForm(form) {
    if (!form || !form.matches('form[data-product-form]')) return;
    var marker = productMarker(form);
    if (!marker) return;
    var variants = parseVariants(form);
    var variant = findVariant(variants, selectedVariantId(form));
    var active = isPreorder(marker, variant);
    var scope = productScope(form);

    scope.querySelectorAll('[data-fe-preorder-badge][data-fe-preorder-context="product"]').forEach(function (badge) { badge.hidden = !active; });
    setNormalBadges(form, active);

    var panel = ensurePanel(form);
    if (panel) {
      var copy = panel.querySelector('[data-fe-preorder-panel-text]');
      if (copy) copy.textContent = preorderCopy(marker);
      panel.hidden = !active;
    }

    var mediaBadge = ensureMediaBadge(form);
    if (mediaBadge) mediaBadge.hidden = !active;

    var button = form.querySelector('[data-product-atc]');
    var buttonText = button ? button.querySelector('.atc-button--text') : null;
    if (button && buttonText) {
      if (active) {
        var preLabel = marker.getAttribute('data-fe-preorder-cta') || 'PRE-ORDINA ORA';
        button.classList.add('fe-atc-preorder');
        button.setAttribute('data-product-atc-preorder','');
        button.setAttribute('aria-label', preLabel);
        buttonText.textContent = preLabel;
      } else {
        button.classList.remove('fe-atc-preorder');
        button.removeAttribute('data-product-atc-preorder');
        if (variant && variant.available) {
          var addLabel = marker.getAttribute('data-fe-add-label') || 'Aggiungi al carrello';
          button.setAttribute('aria-label', addLabel);
          buttonText.textContent = addLabel;
        }
      }
    }

    form.querySelectorAll('.shopify-payment-button').forEach(function (element) { element.classList.toggle('fe-preorder-hidden', active); });
    form.querySelectorAll('[data-surface-pick-up]').forEach(function (element) {
      element.classList.toggle('fe-preorder-hidden', active);
      element.setAttribute('aria-hidden', active ? 'true' : 'false');
    });

    syncEta(form, marker, variant, active);
    syncShippingTab(form, marker, active);
  }

  function schedule(form) {
    window.requestAnimationFrame(function () {
      syncForm(form);
      window.setTimeout(function () { syncForm(form); }, 70);
      window.setTimeout(function () { syncForm(form); }, 180);
    });
  }

  function bindForm(form) {
    if (!form || form.getAttribute('data-fe-preorder-bound') === 'true') return;
    form.setAttribute('data-fe-preorder-bound','true');
    form.addEventListener('change', function () { schedule(form); }, true);
    var selection = form.querySelector('[data-variant-selection]');
    if (selection) {
      new MutationObserver(function () { schedule(form); }).observe(selection, { attributes:true, attributeFilter:['variant'] });
    }
    schedule(form);
  }

  function bindAll(root) {
    root = root || document;
    if (root.matches && root.matches('form[data-product-form]')) bindForm(root);
    if (root.querySelectorAll) root.querySelectorAll('form[data-product-form]').forEach(bindForm);
  }

  function init() {
    bindAll(document);
    document.addEventListener('variant:change', function (event) {
      var form = event.target && event.target.closest ? event.target.closest('form[data-product-form]') : null;
      if (form) schedule(form); else bindAll(document);
    });
    document.addEventListener('variant-change', function (event) {
      var form = event.target && event.target.closest ? event.target.closest('form[data-product-form]') : null;
      if (form) schedule(form); else bindAll(document);
    });
    if (document.body) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) { if (node.nodeType === 1) bindAll(node); });
        });
      }).observe(document.body, { childList:true, subtree:true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once:true });
  else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fe-product-compatibility"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('camera-compatibility')) {
    customElements.define('camera-compatibility', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('[data-fe-compat-dialog]');
        this.input = this.querySelector('[data-fe-compat-input]');
        this.results = this.querySelector('[data-fe-compat-results]');
        this.outcome = this.querySelector('[data-fe-compat-outcome]');
        this.loader = this.querySelector('[data-fe-compat-loader]');
        this.saved = this.querySelector('[data-fe-compat-saved]');
        this.savedResult = this.querySelector('[data-fe-compat-saved-result]');
        this.alternatives = this.querySelector('[data-fe-compat-alternatives]');
        this.trigger = this.querySelector('[data-fe-compat-open]');
        this.data = JSON.parse(this.querySelector('[data-fe-compat-data]').textContent);
        this.targetRoleId = this.dataset.targetRoleId;
        this.parentLabel = this.dataset.parentLabel || 'prodotto principale';
        this.timer = null;
        this.controller = null;

        this.trigger.addEventListener('click', () => this.open());
        this.querySelector('[data-fe-compat-change]').addEventListener('click', () => this.open());
        this.querySelector('[data-fe-compat-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (event) => { if (event.target === this.dialog) this.dialog.close(); });
        this.input.addEventListener('input', () => this.onInput());
        this.results.addEventListener('click', (event) => {
          const option = event.target.closest('[data-fe-finder-product]');
          if (option) this.selectCamera(option);
        });
        document.addEventListener('change', (event) => {
          if (event.target.closest('[data-product-wrapper]')) {
            window.setTimeout(() => this.restoreSaved(), 120);
          }
        });
        this.restoreSaved();
      }

      open() {
        this.outcome.hidden = true;
        this.dialog.showModal();
        window.setTimeout(() => this.input.focus(), 60);
      }

      onInput() {
        const query = this.input.value.trim();
        window.clearTimeout(this.timer);
        this.outcome.hidden = true;
        if (query.length < 2) {
          if (this.controller) this.controller.abort();
          this.results.hidden = true;
          this.results.innerHTML = '';
          this.input.setAttribute('aria-expanded', 'false');
          return;
        }
        this.timer = window.setTimeout(() => this.fetchCameras(query), 250);
      }

      async fetchCameras(query) {
        if (this.controller) this.controller.abort();
        this.controller = new AbortController();
        this.loader.hidden = false;
        const root = window.Shopify?.routes?.root || '/';
        const url = new URL(`${root}search/suggest`, window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '10');
        url.searchParams.set('resources[options][unavailable_products]', 'show');
        url.searchParams.set('resources[options][fields]', 'title,vendor,product_type,variants.title,variants.sku');
        url.searchParams.set('section_id', 'fe-finder-suggestions');
        try {
          const response = await fetch(url, { signal: this.controller.signal, headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const source = doc.querySelector('#shopify-section-fe-finder-suggestions');
          const parentOptions = [...(source?.querySelectorAll('[data-fe-finder-product]') || [])]
            .filter((option) => this.data.parentRoleCodes.includes(option.dataset.feSourceRoleCode));
          this.results.innerHTML = '';
          parentOptions.forEach((option) => this.results.append(option));
          if (!parentOptions.length) this.results.innerHTML = `<div class="fe-finder-empty"><strong>Nessun ${this.parentLabel} configurato trovato.</strong><br>Prova con marca e modello completi.</div>`;
          this.results.hidden = false;
          this.input.setAttribute('aria-expanded', 'true');
        } catch (error) {
          if (error.name !== 'AbortError') {
            this.results.innerHTML = '<div class="fe-finder-empty">Ricerca non disponibile. Riprova tra qualche secondo.</div>';
            this.results.hidden = false;
          }
        } finally {
          this.loader.hidden = true;
        }
      }

      splitIds(value) {
        return (value || '').split('|').map((item) => item.trim()).filter(Boolean);
      }

      currentVariantId() {
        const checked = document.querySelector('form[action*="/cart/add"] [name="id"]');
        const selectedId = checked?.value || '';
        if (selectedId && Object.prototype.hasOwnProperty.call(this.data.variants, selectedId)) return selectedId;
        return String(this.data.defaultVariantId || '');
      }

      currentRules() {
        const variantRules = this.data.variants[this.currentVariantId()] || [];
        return variantRules.length ? variantRules : this.data.productRules;
      }

      evaluate(parent) {
        const parentRules = parent.ruleIds || [];
        const roleMatches = (parent.roleIds || []).includes(this.targetRoleId);
        const ruleMatches = this.currentRules().some((rule) => parentRules.includes(rule));
        return roleMatches && ruleMatches;
      }

      compatibleProductsUrl(parent) {
        const destination = new URL(this.dataset.resultsUrl, window.location.origin);
        const compactIds = (ids) => ids.map((id) => id.split('/').pop()).filter(Boolean).join(',');
        destination.searchParams.set('finder_rules', compactIds(parent.ruleIds || []));
        destination.searchParams.set('finder_roles', compactIds(parent.roleIds || []));
        if (parent.ruleIds?.[0]) destination.searchParams.set('filter.p.m.custom.compatibility', parent.ruleIds[0]);
        if (parent.roleIds?.[0]) destination.searchParams.set('filter.p.m.custom.finder_role', parent.roleIds[0]);
        destination.searchParams.set('finder_source', parent.title || 'Prodotto selezionato');
        destination.searchParams.set('finder_return', window.location.pathname);
        return destination.toString();
      }

      selectCamera(option) {
        const parent = {
          title: option.dataset.feTitle || 'Prodotto selezionato',
          ruleIds: this.splitIds(option.dataset.feRuleIds),
          roleIds: this.splitIds(option.dataset.feRoleIds)
        };
        try { localStorage.setItem('fe_selected_parent', JSON.stringify(parent)); } catch (error) {}
        this.renderOutcome(parent, this.evaluate(parent));
      }

      renderOutcome(parent, compatible) {
        const safeTitle = document.createElement('span');
        safeTitle.textContent = parent.title;
        const name = safeTitle.innerHTML;
        this.outcome.className = `fe-pdp-compat__outcome ${compatible ? 'is-compatible' : 'is-incompatible'}`;
        const alternativesUrl = this.compatibleProductsUrl(parent);
        this.outcome.innerHTML = compatible
          ? `<strong>✓ Compatibile</strong>Questo prodotto è compatibile con ${name}.`
          : `<strong>Non compatibile</strong>Questo prodotto non risulta compatibile con ${name}.<a class="fe-pdp-compat__alternatives" href="${alternativesUrl}">Vedi tutti i prodotti compatibili con ${name}</a>`;
        this.outcome.hidden = false;
        this.results.hidden = true;
        this.saved.className = `fe-pdp-compat__saved ${compatible ? 'is-compatible' : 'is-incompatible'}`;
        this.savedResult.textContent = compatible ? `✓ Compatibile con ${parent.title}` : `Non compatibile con ${parent.title}`;
        this.alternatives.href = alternativesUrl;
        this.alternatives.textContent = `Vedi tutti i prodotti compatibili con ${parent.title}`;
        this.alternatives.hidden = compatible;
        this.saved.hidden = false;
        this.trigger.hidden = true;
      }

      restoreSaved() {
        let parent = null;
        try {
          parent = JSON.parse(localStorage.getItem('fe_selected_parent'));
          if (!parent) parent = JSON.parse(localStorage.getItem('fe_selected_camera'));
        } catch (error) {}
        if (parent?.title) this.renderOutcome(parent, this.evaluate(parent));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
